import React from "react";

import { countriesPhoneNumber } from "../../constants/countriesPhoneNumber";
import { Input, Dropdown } from "../../kaya";

import styles from "./dropdownWithInput.module.scss";

interface Props {
  onChange: (id: string) => (val: { code: string; number: string }) => void;
  error: string;
  phone: {
    code: string;
    number: string;
  };
}

const DropdownWithInput: React.FC<Props> = (props) => {
  const { onChange, error, phone } = props;

  return (
    <div className={styles.dropdownWithInput}>
      <Dropdown
        options={countriesPhoneNumber}
        width="105px"
        value={phone.code}
        onMenuItemClick={(country) =>
          onChange("phone")({
            code: country.label,
            number: phone.number,
          })
        }
        inputWrapperClassName={styles.dropdown}
        // errors={{ phone: error }}
        // id="phone"
      />

      <Input
        type="number"
        width="100%"
        placeholder="Phone No."
        maxLength={9}
        value={phone.number}
        id="phone"
        errors={{ phone: error }}
        onChange={(val) =>
          onChange("phone")({
            code: phone.code,
            number: val,
          })
        }
        className={styles.input}
      />
    </div>
  );
};

export default DropdownWithInput;
